import React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash';
import { NEW_BETS } from '../../../consts/navigation';
import { FETCH_NEW_BETS } from '../../../redux/BetsTables';
import { vehicleTypes } from '../../../consts/vehicleTypes';
import { connect } from 'react-redux';
import Table from '../../Table/Table';
import { tablesHeaders } from '../../../consts/tablesConf';
import SingleRow from '../SingleRow';

const NewBetsContainer = ({ fetchNewBets, totalCount, totalPages, handleShowOffer, newBets, isMobile, vehicleType, }) => {

  return (
    <Table
      whichFolder={NEW_BETS}
      tableHeaders={tablesHeaders[vehicleType][NEW_BETS]}
      fetchOffers={fetchNewBets}
      totalCount={totalCount}
      totalPages={totalPages}
      renderRow={SingleRow(isMobile, vehicleType)}
      onRowClick={handleShowOffer}
      items={newBets}
    />
  )
}


const mapStateToProps = (state) => {
  return {
    newBets: get(state, ['bets', NEW_BETS, 'data']),
    totalCount: get(state, ['bets', NEW_BETS, 'total_count']),
    totalPages: get(state, ['bets', NEW_BETS, 'total_pages']),
    isMobile: get(state, ['layout', 'isMobile']),
    vehicleType: get(state, ['vehicleType', 'vehicleType']),
  };
};

const mapDispatchToProps = (dispatch) => {
  return { fetchNewBets: () => dispatch(FETCH_NEW_BETS()), };
};

NewBetsContainer.propTypes = {
  handleShowOffer: PropTypes.func.isRequired,
  fetchNewBets: PropTypes.func.isRequired,
  newBets: PropTypes.object.isRequired,
  totalCount: PropTypes.number,
  totalPages: PropTypes.number,
  vehicleType: PropTypes.oneOf(Object.keys(vehicleTypes)).isRequired,
  isMobile: PropTypes.any.isRequired,
};

NewBetsContainer.defaultProps = {
  newBets: [],
  totalCount: 0,
  totalPages: 1,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewBetsContainer);
